import React from 'react'
import { styled } from '@mui/material/styles';
import clsx from 'clsx'
import {
  AppBar,
  Toolbar,
  IconButton,
  Typography,
  ButtonBase,
  MenuList,
  MenuItem,
  Popper,
  Grow,
  Paper,
  ClickAwayListener,
} from '@mui/material'

import IconMenu from '@mui/icons-material/Menu'

import HeaderDemo from './HeaderDemo'
import bellplusicon from '../../../images/BellPlus-LogoWhite.svg'
import HeaderProfile from './HeaderProfile'
import * as utils from '../../../util/bellplus-utils'
import routes from '../../../constants/Routes'
import { useNavigate } from 'react-router-dom';

const PREFIX = 'Header';

const classes = {
  header: `${PREFIX}-header`,
  toolbar: `${PREFIX}-toolbar`,
  menuButton: `${PREFIX}-menuButton`,
  actions: `${PREFIX}-actions`,
  notificationsButton: `${PREFIX}-notificationsButton`,
  title: `${PREFIX}-title`
};

const StyledAppBar = styled(AppBar)((
  {
    theme
  }
) => ({
  [`&.${classes.header}`]: {
    background: '#393937',
    color: '#F4FFFF',
    boxShadow: 'none',
  },

  [`& .${classes.toolbar}`]: {},
  [`& .${classes.menuButton}`]: { marginLeft: '-1.2rem', marginTop: 10 },

  [`& .${classes.actions}`]: {
    marginLeft: 'auto',
    alignItems: 'center',
    display: 'flex',
  },

  [`& .${classes.notificationsButton}`]: {
    marginRight: 23,
  },

  [`& .${classes.title}`]: {
    flexGrow: 1,
  }
}));

interface HeaderProps {
  onToggle?: (event: React.MouseEvent<HTMLButtonElement>) => void
}

const Header = ({ onToggle }: HeaderProps) => {
  const navigate = useNavigate()
  const userDetails = utils.getData('userDetails')


  const [open, setOpen] = React.useState(false)
  //const anchorRef = React.useRef<HTMLDivElement>(null);
  const [anchorEl, setAnchorEl] = React.useState<any>(null)

  const handleToggle = (event: any) => {
    setAnchorEl(event.currentTarget)
    setOpen((prevOpen) => !prevOpen)
  }

  const handleClose = (event: any) => {
    if (anchorEl) {
      if (anchorEl.contains(event.target)) {
        return
      }
      setOpen(false)
    }
  }

  function handleListKeyDown(event: any) {
    if (event.key === 'Tab') {
      event.preventDefault()
      setOpen(false)
    }
  }

  const handleProfile = () => {
    navigate(routes.USER_PROFILE.path)
    setOpen(false)
  }

  const handleLogOut = () => {
    utils.removeData('userDetails')
    utils.removeData('userCredentials')
    navigate(routes.LOGIN.path)
  }

  return (
    <StyledAppBar position="absolute" className={classes.header}>
      <Toolbar className={classes.toolbar}>
        <IconButton
          edge="start"
          color="inherit"
          aria-label="Toggle sidebar"
          onClick={onToggle}
          className={clsx(classes.menuButton)}
          size="large">
          <IconMenu />
        </IconButton>
        <img
          src={bellplusicon}
          style={{
            height: 54,
            width: '6.5%',
          }}
          alt="bellplus logo"
        />
        <HeaderDemo />
        <div className={classes.actions}>
          {/* <HeaderSearch />
          <HeaderHome /> */}
          {/* <HeaderNotifications /> */}
          {/* <HeaderProfile /> */}
          <ButtonBase onClick={handleToggle}>
            <Typography>
              {userDetails && userDetails.data && userDetails.data.username
                ? userDetails.data.username
                : ''}
            </Typography>
            <HeaderProfile />
          </ButtonBase>
          <Popper
            open={open}
            anchorEl={anchorEl}
            role={undefined}
            transition
            placement={'bottom'}
            disablePortal
          >
            {({ TransitionProps }) => (
              <Grow {...TransitionProps}>
                <Paper>
                  <ClickAwayListener onClickAway={handleClose}>
                    <MenuList
                      autoFocusItem={open}
                      id="menu-list-grow"
                      onKeyDown={handleListKeyDown}
                    >
                      <MenuItem onClick={handleProfile}>Profile</MenuItem>
                      <MenuItem onClick={handleLogOut}>Logout</MenuItem>
                    </MenuList>
                  </ClickAwayListener>
                </Paper>
              </Grow>
            )}
          </Popper>
        </div>
      </Toolbar>
    </StyledAppBar>
  );
}

export default Header
